import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=da4778d2&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da4778d2')) {
      api.createRecord('da4778d2', component.options)
    } else {
      api.reload('da4778d2', component.options)
    }
    module.hot.accept("./Body.vue?vue&type=template&id=da4778d2&", function () {
      api.rerender('da4778d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Body.vue"
export default component.exports